<template>
  <v-footer
    dark
    padless
    color="black"
    style="
      border-top: 1px solid #e1e1e1;
      position: fixed;
      bottom: 0;
      width: 100%;
    "
  >
    <v-row style="height:22px" no-gutters class="d-flex justify-center align-start mx-auto">
      <v-col cols="6" md="6" class="d-flex justify-center">
        <div class=" text-caption">
          {{ $t("extras.footer") }}
        </div>
      </v-col>

      <v-col cols="6" md="6" class="d-flex text-caption  pt-1 justify-center">
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn style="align-items: flex-start;" v-bind="attrs" v-on="on" plain>
              <v-img
                v-if="isPtBRLocale"
                style="height: 15px"
                content-class="rounded-sm"
                class="rounded-sm mr-2"
                aspect-ratio="16/9"
                max-width="20"
                width="32"
                :src="require(`./../assets/brazil_flag.png`)"
              />
              <v-img
                v-else
                style="height: 15px"
                content-class="rounded-sm"
                class="rounded-sm mr-2"
                aspect-ratio="16/9"
                max-width="20"
                width="32"
                :src="require(`./../assets/usd_flag.png`)"
              />
              {{ $t("extras.language") }}
            </v-btn>
          </template>

          <v-list style="background-color: white">
            <v-list-item link @click="changeLanguageFn('en')">
              <v-img
                style="height: 32px"
                content-class="rounded-lg"
                class="rounded-lg mr-2"
                aspect-ratio="16/9"
                max-width="32"
                width="32"
                :src="require(`./../assets/usd_flag.png`)"
              />
              <v-list-item-title>
                <span style="color: #000">EN-US</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="changeLanguageFn('pt')">
              <v-img
                style="height: 32px"
                content-class="rounded-lg"
                class="rounded-lg mr-2"
                aspect-ratio="16/9"
                max-width="32"
                width="32"
                :src="require(`./../assets/brazil_flag.png`)"
              />
              <v-list-item-title>
                <span style="color: #000">PT-BR</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  inject: ["changeLanguageFn"],
  computed: {
    isPtBRLocale() {
      return this.$i18n.locale === "pt";
    },
  },
};
</script>
